module.exports = __webpack_public_path__ + "static/classifieds-9740cb99371d93a49496a06202b3a4bd.png";